module.exports = __webpack_public_path__ + "media/images/blue_infinite_circle-7bd4c33f.png";